import DirectionsCarFilled from '@mui/icons-material/DirectionsCarFilled';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { AppImage } from '@/components/atoms';
import { type VehicleImage } from '@/services/vehicles/types';

type Props = {
  image: VehicleImage | null;
  /** Used when the image has no alt text of its own. */
  fallbackAlt: string;
  priority?: boolean;
  sizes?: string;
};

/** A vehicle photo in a fixed 3:2 frame, or a labelled placeholder (§4). */
export function VehiclePhoto({ image, fallbackAlt, priority = false, sizes }: Props) {
  return (
    <Box
      sx={{
        position: 'relative',
        aspectRatio: '3 / 2',
        bgcolor: 'surfaceVariant',
        overflow: 'hidden',
      }}
    >
      {image ? (
        <AppImage
          src={image.url}
          alt={image.alt ?? fallbackAlt}
          width={image.width ?? 1200}
          height={image.height ?? 800}
          priority={priority}
          {...(sizes ? { sizes } : {})}
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />
      ) : (
        <Box
          role="img"
          aria-label={`${fallbackAlt} (photo coming soon)`}
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'grid',
            placeItems: 'center',
            color: 'text.disabled',
          }}
        >
          <DirectionsCarFilled aria-hidden sx={{ fontSize: 72 }} />
          <Typography variant="caption" sx={{ position: 'absolute', bottom: 8 }}>
            Photo coming soon
          </Typography>
        </Box>
      )}
    </Box>
  );
}
